import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WFTCartDialogOutputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { groupBy } from 'lodash';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';




@Component({
	selector: 'app-wft-cart-dialog',
	templateUrl: './wft-cart-dialog.component.html',
	styleUrls: ['./wft-cart-dialog.component.css']
})
export class WftCartDialogComponent implements OnInit {
	businessGroupList: BusinessGroupModel[] = [];
	businessGroupClearFlag = 'N';
	businessGroupId: number | null = null;

	/** Member cart data source */
	memberLeftList: ProjectMemberModel[] = [];
	/** for looping purpose */
	memberLeftListCopy: ProjectMemberModel[] = [];
	memberRightList: any = [];

	/** Selected Member events array */
	memberSelectedList: any = [];

	/** Role cart data source.Left side data  */
	roleLeftList: RoleFeatureModel[] = [];

	roleRightList: any = [];

	/** Selected Role events array */
	roleSelectedList: any = [];
	cartMemberRequest = {};
	cartRoleRequest = {};

	/** Previous selected business group id. Values comes from parent */
	previousBusinessGroupId: number | null = null;
	parentDataCopy: any;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: {
			roleTextWithValue: { value: string | number, text: string }[],
			memberTextWithValue: { value: string | number, text: string }[],
			roleEventsList: any[],
			memberEventList: any[],
			previousBusinessGroupId?: number,
			isCc?: boolean,
		},
		public dialogRef: MatDialogRef<WftCartDialogComponent>,
		public projectMemberLinkService: ProjectMemberLinkService,
		public organizationService: OrganizationService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public commonService: CommonService,
		public workflowTemplateService: WorkflowTemplateService,
		public notificationService: NotificationService,
	) { }

	ngOnInit() {
		this.parentDataCopy = JSON.parse(JSON.stringify(this.data));

		if (this.data.previousBusinessGroupId != null) {
			this.previousBusinessGroupId = (!!this.parentDataCopy && !!this.parentDataCopy.TemplateDetails['SrcBG']) ? this.parentDataCopy.TemplateDetails['SrcBG'] : this.data.previousBusinessGroupId;
		}
		this.callApis();
		if (this.data.memberEventList.length) {
			this.getSelectedMemberCartItems(this.data.memberEventList);
		}

		if (this.data.roleEventsList.length) {
			this.getSelectedRoleCartItems(this.data.roleEventsList);
		}

		this.setRoleCartParams();
		this.setMemberCartParams();
	}


	async callApis() {
		let response: any = await this.projectMemberLinkService.getProjectBusinessGroup(((!!this.parentDataCopy && !!this.parentDataCopy.TemplateDetails['SrcProject']) ? this.parentDataCopy.TemplateDetails['SrcProject'] : this.commonService.getProjectId())).toPromise();
		if (response && response.length > 0)
			this.businessGroupList = response.filter((each: any) => each.is_Active);

	}

	//  EIPAutoCompleteEventModel<BusinessGroupModel>
	changeBusinessGroup(event: any,) {
		this.businessGroupClearFlag = 'N';
		if (event.value != '-2') {
			this.businessGroupId = Number(event.value);
			if (this.data.previousBusinessGroupId == this.businessGroupId) {
				this.getMemberList();
				this.getRoleList();
			} else {
				this.getSelectedRoleCartItems([]);
				this.getSelectedMemberCartItems([]);

				this.data.roleEventsList = [];
				this.data.roleTextWithValue = [];

				this.data.memberEventList = [];
				this.data.memberTextWithValue = [];

				this.getMemberList();
				this.getRoleList();
			}
		} else {
			this.clearData();
		}
	}

	async getMemberList() {
		if (this.businessGroupId)
			this.memberLeftList = await this.projectMemberLinkService.getSelectedMemberList(((!!this.parentDataCopy && !!this.parentDataCopy.TemplateDetails['SrcProject']) ? this.parentDataCopy.TemplateDetails['SrcProject'] : this.commonService.getProjectId()), this.businessGroupId).toPromise();
		this.setMemberRightSideData();
	}


	setMemberRightSideData() {
		this.memberRightList = this.data.memberTextWithValue;

		if (this.memberRightList.length) {
			let tempLeftData: any = [];
			let grpdData = groupBy(this.memberRightList, 'value');

			this.memberLeftList.forEach(each => {
				if (!(grpdData[each.memberId] && grpdData[each.memberId].length)) {
					tempLeftData.push(each);
				}
			});
			this.memberLeftList = tempLeftData;
		}

		this.setMemberCartParams();
	}

	setRoleRightSideData() {
		this.roleRightList = this.data.roleTextWithValue;

		if (this.roleRightList.length) {
			let tempLeftData: any = [];
			let grpdData = groupBy(this.roleRightList, 'value');

			this.roleLeftList.forEach(each => {
				if (!(grpdData[each.dedId] && grpdData[each.dedId].length)) {
					tempLeftData.push(each);
				}
			});
			this.roleLeftList = tempLeftData;
		}
		this.setRoleCartParams();
	}


	async getRoleList() {
		this.roleLeftList = await this.mapRoleFeatureService.getDedAgainstDe('Role', this.businessGroupId, null, null, null, ((!!this.parentDataCopy && !!this.parentDataCopy.TemplateDetails['SrcProject']) ? this.parentDataCopy.TemplateDetails['SrcProject'] : null)).toPromise();
		this.setRoleRightSideData();
	}

	setMemberCartParams() {
		this.cartMemberRequest = {
			'params': {
				'LockingType': 'P',
				'selectedCartItems': this.memberRightList,
			},
			'settings': {
				'mode': 'popup',
				'textField': 'memberName',
				'valueField': 'memberId',
				'cartLabel': 'Members',
				'minimumSelectedItemCount': 0
			},
			'dataSource': this.memberLeftList,
		}
	}

	getSelectedMemberCartItems(event: any) {
		this.memberSelectedList = event;
	}

	setRoleCartParams() {
		this.cartRoleRequest = {
			'params': {
				'LockingType': 'P',
				'selectedCartItems': this.roleRightList,
			},
			'settings': {
				'mode': 'popup',
				'textField': 'dedDescription',
				'valueField': 'dedId',
				'cartLabel': 'Roles',
				'minimumSelectedItemCount': 0
			},
			'dataSource': this.roleLeftList,
		}

	}

	getSelectedRoleCartItems(event: any) {
		this.roleSelectedList = event;
	}

	closeDialog() {
		this.dialogRef.close(null);
	}

	save() {

		let output: WFTCartDialogOutputModel = {
			'roleSelectedIds': [],
			'roleTextWithValue': [],
			'roleSelectedNames': [],
			'roleEventsList': [],

			'memberSelectedIds': [],
			'memberTextWithValue': [],
			'memberSelectedNames': [],
			'memberEventList': [],

			'totalSelectedNames': [],//roleSelectedNames + memberSelectedNames
		};

		this.roleSelectedList.forEach((eachRole: any) => {
			output.roleEventsList.push(eachRole);
			output.roleSelectedIds.push(eachRole.value);

			if (eachRole.additionalValues) {
				output.roleTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(eachRole.value, eachRole.additionalValues.dedDescription));
				output.roleSelectedNames.push(eachRole.additionalValues.dedDescription);
			} else {
				let text = eachRole.text.split('-'),
					value = text[0].trim(),
					name = text[1].trim();

				output.roleTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(value, name));
				output.roleSelectedNames.push(name);
			}
		});

		this.memberSelectedList.forEach((eachMember: any) => {
			output.memberEventList.push(eachMember);
			output.memberSelectedIds.push(eachMember.value);

			if (eachMember.additionalValues) {
				output.memberTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(eachMember.value, eachMember.additionalValues.memberName));
				output.memberSelectedNames.push(eachMember.additionalValues.memberName);
			} else {
				let text = eachMember.text.split('-'),
					value = text[0].trim(),
					name = text[1].trim();

				output.memberTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(value, name));
				output.memberSelectedNames.push(name)
			}
		});

		output.totalSelectedNames = [...output.roleSelectedNames, ...output.memberSelectedNames];

		output.previousBusinessGroupId = this.businessGroupId;
		// return;
		this.dialogRef.close(output);

	}

	clearData() {
		this.businessGroupClearFlag = "Y";
		this.businessGroupId = null;

		this.roleRightList = [];
		this.roleLeftList = [];
		this.roleSelectedList = [];

		this.memberRightList = this.memberLeftList = this.memberSelectedList = [];
		this.data = {
			roleTextWithValue: [],
			memberTextWithValue: [],
			roleEventsList: [],
			memberEventList: [],
		};

		this.setRoleCartParams();
		this.setMemberCartParams();
	}
}
